module.exports = __webpack_public_path__ + "static/media/img-1.d4b42ddd.jpg";